<div class="dialog-viewer">
    <h2 mat-dialog-title>Edit Registration: {{registration.playerRegistrationCode}}</h2>
    <mat-dialog-content>
        <div class="container-fluid">
            <div class="row">
                <mat-progress-bar mode="indeterminate" *ngIf="isSaving"></mat-progress-bar>
            </div>
            <div class="row">
                <div class="col">
                    <mat-form-field>
                        <mat-label>First Name</mat-label>
                        <input matInput placeholder="First Name" [(ngModel)]="registration.firstName">
                    </mat-form-field>
                </div>
                <div class="col">
                    <mat-form-field>
                        <mat-label>Last Name</mat-label>
                        <input matInput placeholder="Last Name" [(ngModel)]="registration.lastName">
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <mat-form-field>
                        <mat-label>Starting Hole</mat-label>
                        <input matInput placeholder="Starting Hole" [(ngModel)]="registration.startingHole" />
                    </mat-form-field>
                </div>
                <div class="col">
                    <mat-form-field>
                        <mat-label>Team Captain</mat-label>
                        <input matInput placeholder="Team Captain" [(ngModel)]="registration.teamCaptain" />
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <mat-checkbox [(ngModel)]="registration.isCheckedIn">Is Checked In</mat-checkbox>
                </div>
                <div class="col">
                    <mat-checkbox [(ngModel)]="registration.hasPaid">Has Paid</mat-checkbox>
                </div>
                <div class="col">
                    <mat-checkbox [(ngModel)]="registration.skins">Skins</mat-checkbox>
                </div>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <div class="text-center">
            <button mat-raised-button (click)="submit()" [disabled]="isSaving">{{submitText}}</button>
            <button mat-raised-button class="warning" (click)="close()" [disabled]="isSaving">Close</button>
        </div>
    </mat-dialog-actions>
</div>